import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { IApplicationConfiguration } from '../models/app_config_model';
import { UserModesService } from './user_modes_service';
export class UserModesController {
  private userName: string;
  private campusUrl: string;
  private isAdvisorMode: boolean = false;
  private hasStudentRole: boolean = true;
  private hasContentManagerRole: boolean = false;
  private showDialog = false;
  private studentNk = '';

  constructor(
    private $state: ng.ui.IStateService,
    private accountModel: AccountModel,
    private LEANAP_EXPOSE_LEANAP_APIS: string,
    private ngUserModesService: UserModesService,
    private appConfigModel: IApplicationConfiguration
  ) {}

  $onInit() {
    this.userName = this.accountModel.fullname;
    this.campusUrl = this.appConfigModel.getConfigProperty(`core-campus_url`);
    this.hasStudentRole = this.ngUserModesService.hasStudentRole;
    this.hasContentManagerRole = this.ngUserModesService.hasContentManagerRole;
    // TODO: Auth Check should be in force_app_config_load.es
    if (!this.accountModel.isLoggedIn()) {
      this.ngUserModesService.forceAuthentication();
    }
    if (this.ngUserModesService.isAdvisorOnly) {
      this.isAdvisorMode = true;
    }
  }

  isPlanner3Enabled() {
    return this.appConfigModel.isFeatureEnabled(this.LEANAP_EXPOSE_LEANAP_APIS);
  }
  accessStudentAP() {
    this.showDialog = true;
  }
  hideDialog() {
    this.showDialog = false;
  }
  updateStudentNk(evnt: any) {
    this.studentNk = evnt.detail.value;
  }
  navigateToAP3Advisor() {
    window.sessionStorage.setItem('external_id', this.studentNk);
    window.location.assign('#/my/ap3/advisor');
  }
}

export class UserModesComponent implements angular.IComponentOptions {
  public templateUrl: string = 'lib/user_modes/user_modes.html';
  public controller: any = UserModesController;
}



// WEBPACK FOOTER //
// ./app/lib/user_modes/user_modes.ts